import { LeaseCarDataResponse } from 'types';

import {
	LeaseCarDataActionTypes,
	RESET_LEASE_CAR_DATA,
	SET_LEASE_CAR_DATA,
} from './leaseCarDataActionTypes';

export const setLeaseCarData = (payload: LeaseCarDataResponse): LeaseCarDataActionTypes => ({
	type: SET_LEASE_CAR_DATA,
	payload,
});

export const resetLeaseCarData = (): LeaseCarDataActionTypes => ({
	type: RESET_LEASE_CAR_DATA,
});
